//@ts-ignore
import ReactDom from 'react-dom';
import { ReactNode } from 'react';
import { Close, Content, Header, ModalStyled, OutModalStyled } from './styles';
import { Heading } from '../DefaultStylesTypography';

interface IPropsModalDesigner {
  id: string;
  children: ReactNode;
  setState: Function;
  isOpen: boolean;
  title?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullSize?: boolean;
  titleColor?: string;
}

export function ModalDesigner({
  children,
  id,
  setState,
  isOpen,
  title = '',
  size = 'lg',
  fullSize = false,
  titleColor,
}: IPropsModalDesigner) {
  //@ts-ignore
  function handleOutSideClick(e) {
    if (e.target.id === id) setState(false);
  }

  return ReactDom.createPortal(
    <>
      {isOpen && (
        <OutModalStyled id={id} onClick={handleOutSideClick}>
          <ModalStyled size={size} fullSize={fullSize}>
            <Header titleColor={titleColor}>
              <Heading as="h4" variant="quaternary">
                {title}
              </Heading>
              <Close onClick={() => setState(false)} />
            </Header>
            <Content>{children}</Content>
          </ModalStyled>
        </OutModalStyled>
      )}
    </>,
    // @ts-ignore
    document.querySelector('.portalModalDiv')
  );
}
